import { ConfigurationType, StoredAirHandlerType } from 'data/types';
import {
  ExportedConfigurationJson,
  ExportedZoneJson
} from 'types/structure-json';
import {
  transformCondensersForDatabase,
  transformLineSetsForDatabase
} from 'utils/configuration-db';

function transformZonesForExport(
  config: ConfigurationType
): ExportedZoneJson[] {
  return config.condensers.flatMap((condenser) =>
    condenser.zones.map((zone) => ({
      uniqueId: zone.uniqueId,
      condenserUniqueId: condenser.uniqueId,
      label: zone.name,
      zoneTypeCode: zone.type,
      existingSystemUniqueId: zone.existingSystemId ?? null,
      valid: zone.valid ?? false,
      modified: zone.modified ?? false,
      spaceUniqueIds: zone.zoneItems.map((item) => item.structureItemId),
      spaceItems: zone.zoneItems.map((item) => ({
        uniqueId: item.uniqueId,
        structureItemId: item.structureItemId,
        isPartition: item.isPartition ?? false,
        isSeparateSystem: item.isSeparateSystem ?? false,
        registerOverride: item.registerOverride ?? null,
        additionalSupplyRuns: item.additionalSupplyRuns ?? [],
        supplyRunPoints: item.supplyRunPoints ?? []
      })),
      returnOverride: zone.returnOverride ?? null,
      additionalReturnRuns: zone.additionalReturnRuns ?? [],
      returnRunPoints: zone.returnRunPoints ?? []
    }))
  );
}

function transformAirHandlersForExport(
  config: ConfigurationType
): StoredAirHandlerType[] {
  return config.condensers.flatMap((condenser) =>
    condenser.zones.flatMap((zone) =>
      zone.airHandler
        ? [
            {
              uniqueId: zone.airHandler.uniqueId,
              zoneUniqueId: zone.uniqueId,
              airHandlerTypeCode: zone.airHandler.airHandlerTypeCode,
              positionX: zone.airHandler.positionX,
              positionY: zone.airHandler.positionY,
              valid: zone.airHandler.valid ?? false,
              modified: zone.airHandler.modified ?? false,
              userPositioned: zone.airHandler.userPositioned,
              concealedLocation: zone.airHandler.concealedLocation
            }
          ]
        : []
    )
  );
}

export function transformConfigurationsForExport(
  configs: ConfigurationType[],
  defaultLevelUniqueId: string
): ExportedConfigurationJson[] {
  return configs.map((config) => ({
    uniqueId: config.uniqueId,
    instanceUniqueId: null,
    label: config.name,
    valid: config.valid ?? false,
    modified: config.modified ?? false,
    aiGenerated: config.aiGenerated,
    condensers: transformCondensersForDatabase(
      config.condensers,
      defaultLevelUniqueId
    ),
    zones: transformZonesForExport(config),
    airHandlers: transformAirHandlersForExport(config),
    lineSets: transformLineSetsForDatabase(config.lineSets)
  }));
}
